"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = void 0;
const index_1 = require("./index");
exports.cache = (() => {
    const caches = {};
    const call = (fn, ...params) => {
        const id = index_1.hashObject(params);
        if (!caches[id]) {
            /** @type {Promise} */
            const ret = fn(...params);
            caches[id] = ret.catch((err) => {
                caches[id] = null;
                throw err;
            });
        }
        return caches[id];
    };
    return call;
})();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3V0aWxzL2NhY2hlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFxQztBQUV4QixRQUFBLEtBQUssR0FBRyxDQUFDLEdBQUcsRUFBRTtJQUN6QixNQUFNLE1BQU0sR0FBRyxFQUFFLENBQUM7SUFFbEIsTUFBTSxJQUFJLEdBQUcsQ0FBQyxFQUFZLEVBQUUsR0FBRyxNQUFNLEVBQUUsRUFBRTtRQUN2QyxNQUFNLEVBQUUsR0FBRyxrQkFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBRTlCLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLEVBQUU7WUFDZixzQkFBc0I7WUFDdEIsTUFBTSxHQUFHLEdBQUcsRUFBRSxDQUFDLEdBQUcsTUFBTSxDQUFDLENBQUM7WUFFMUIsTUFBTSxDQUFDLEVBQUUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxHQUFHLEVBQUUsRUFBRTtnQkFDN0IsTUFBTSxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQztnQkFDbEIsTUFBTSxHQUFHLENBQUM7WUFDWixDQUFDLENBQUMsQ0FBQztTQUNKO1FBRUQsT0FBTyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDcEIsQ0FBQyxDQUFDO0lBRUYsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDLENBQUMsRUFBRSxDQUFDIn0=